export default "__VITE_ASSET__Ci7BMKz0__"